import React, { useState } from 'react'
import Classes from './FeaturedSection.module.css'
import BrandSlider from './BrandSlider/BrandSlider';
import { useNavigate } from 'react-router-dom';
import { AdidasProducts, JordansProducts, LVProducts, NewBalanceProducts, NikeProducts } from '../../../data/products';

export default function FeaturedSection() {
    const navigateTo = useNavigate();

    const handleNavigate = (page) => {
        navigateTo(page);
    }

    return (
        <div className={Classes.hero} id='brands-section' >
            <div className={Classes.miniText} > Available Brands </div>
            <h1 className={Classes.subheading}> Explore the Best in Footwear </h1>
            <p className={Classes.text}>
                Our curated selection of the most renowned brands in the world.
            </p>

            <div className={Classes.categoryCon} >
                <div className={Classes.category} >
                    <div className={Classes.card_img} onClick={() => { handleNavigate('/nike') }} >
                        <img src={'https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1748022843/nikecategory_za0jv8.webp'}
                            className={Classes.card_inner_img}
                            draggable={false}
                            rel="noopener noreferrer"
                        />
                    </div>
                    <h2 className={Classes.title} onClick={() => { handleNavigate('/nike') }} > Nike </h2>
                </div>
                <div className={Classes.category} >
                    <div className={Classes.card_img} onClick={() => { handleNavigate('/jordans') }} >
                        <img src={'https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1748022844/jordanscategory_bwut37.webp'}
                            className={Classes.card_inner_img}
                            draggable={false}
                            rel="noopener noreferrer"
                        />
                    </div>
                    <h2 className={Classes.title} onClick={() => { handleNavigate('/jordans') }} > Jordans </h2>
                </div>
                <div className={Classes.category} >
                    <div className={Classes.card_img} onClick={() => { handleNavigate('/adidas') }} >
                        <img src={'https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1748022844/adidascategory_ypjeh4.webp'}
                            className={Classes.card_inner_img}
                            draggable={false}
                            rel="noopener noreferrer"
                        />
                    </div>
                    <h2 className={Classes.title} onClick={() => { handleNavigate('/adidas') }} > Adidas </h2>
                </div>
                <div className={Classes.category} >
                    <div className={Classes.card_img} onClick={() => { handleNavigate('/new-balance') }} >
                        <img src={'https://res.cloudinary.com/ddwxuh0d0/image/upload/f_auto,q_auto/v1748022844/nbcategory_xbegtr.webp'}
                            className={Classes.card_inner_img}
                            draggable={false}
                            rel="noopener noreferrer"
                        />
                    </div>
                    <h2 className={Classes.title} onClick={() => { handleNavigate('/new-balance') }} > New Balance </h2>
                </div>
            </div>

            <div className={Classes.body} >
                <BrandSlider title={'Nike'} Products={NikeProducts} page={'/nike'} />
                <BrandSlider title={'Jordans'} Products={JordansProducts} page={'/jordans'} />
                <BrandSlider title={'Adidas'} Products={AdidasProducts} page={'/adidas'} />
                <BrandSlider title={'New balance'} Products={NewBalanceProducts} page={'/new-balance'} />
                <BrandSlider title={'LV'} Products={LVProducts} page={'/lv'} />
            </div>

        </div>
    )
}
